import { message } from 'antd';
import axios from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import {
  pauseOrResumeCampaignList,
  pauseOrResumeCampaignListFailed,
  pauseOrResumeCampaignListSucceeded,
} from 'redux/slice/campaign-planner/CamapignList.slice';
import {
  CreateCampaignActionType,
  UpdateCampaignActionType,
} from 'redux/slice/campaign-planner/types';
import {
  createCampaign,
  createCampaignFailed,
  createCampaignSucceeded,
  pauseOrResumeCampaign,
  pauseOrResumeCampaignFailed,
  pauseOrResumeCampaignSucceeded,
  updateCampaign,
} from 'redux/slice/strategy/strategy';
import { parseAxiosError } from 'utils/helper';

import { ApiStatusCodes } from '../../../services/api/apiStatusCode';
import { campaignPlanner } from '../../../services/api/endPoints';
import { HTTPClient } from '../../../services/api/http-client';
import { ICreateCampaignResponse } from './Outreach.types';

export function* createCampaignSaga(action: CreateCampaignActionType) {
  try {
    const result: ICreateCampaignResponse = yield HTTPClient.PostRequest(
      campaignPlanner.CREATE_CAMPAIGN,
      action.payload.payload
    );

    if (
      result.status === ApiStatusCodes.SUCCESS ||
      result.status === ApiStatusCodes.CREATED
    ) {
      yield put(createCampaignSucceeded(result.data.data));
      message.success(result?.data?.message || 'Campaign created successfully');
      action.payload.handleSegmentationSuccessCallback(
        result.data.data.campaignId
      );
    } else {
      yield put(createCampaignFailed());
    }
  } catch (error: any) {
    message.error(
      error?.response?.data?.error ||
        'An error occurred while creating campaigns'
    );
    yield put(createCampaignFailed());
  }
}

export function* updateCampaignSaga(action: UpdateCampaignActionType) {
  try {
    const result: ICreateCampaignResponse = yield HTTPClient.PutRequest(
      `${campaignPlanner.UPDATE_CAMPAIGN(
        action.payload.payload.campaignId,
        action.payload.payload.lenderId,
        action.payload.submitPlan
      )}`,
      action.payload.payload
    );

    if (result?.status === ApiStatusCodes.SUCCESS && result?.data) {
      // eslint-disable-next-line @typescript-eslint/naming-convention

      // For now we are processing only lender entities
      yield put(createCampaignSucceeded(result?.data?.data));
      message.success(
        result?.data?.message || 'Campaign dates updated successfully'
      );
      action.payload.handleSegmentationSuccessCallback(
        result?.data?.data.campaignId
      );
    } else {
      yield put(createCampaignFailed());
    }
  } catch (error) {
    // Handle API call failure or network errors
    yield put(createCampaignFailed());
    if (axios.isAxiosError(error)) {
      // Ensure the error is an AxiosError
      const parsedError = parseAxiosError(error);
      message.error(
        parsedError?.response.data.error || 'Failed to update campaign dates'
      );
    }
  }
}

export function* pauseOrResumeCampaignSaga(action: any) {
  try {
    const { campaignId, status } = action.payload;
    const result: ICreateCampaignResponse = yield HTTPClient.PostRequest(
      campaignPlanner.PAUSE_CAMPAIGN(campaignId, status)
    );

    if (result?.status === ApiStatusCodes.SUCCESS && result?.data?.data) {
      // eslint-disable-next-line @typescript-eslint/naming-convention

      // For now we are processing only lender entities
      yield put(pauseOrResumeCampaignSucceeded(result.data.data));
      yield put(pauseOrResumeCampaignListSucceeded(result.data.data));
      message.success(result?.data?.message || 'Campaign paused successfully');
    } else {
      yield put(
        pauseOrResumeCampaignListFailed({
          error: {
            message: 'No Token Found',
          },
        })
      );
      yield put(
        pauseOrResumeCampaignFailed({
          error: {
            message: 'No Token Found',
          },
        })
      );
    }
  } catch (error) {
    // Handle API call failure or network errors
    yield put(
      pauseOrResumeCampaignListFailed({
        error: {
          message: 'No Token Found',
        },
      })
    );
    yield put(
      pauseOrResumeCampaignFailed({
        error: {
          message: 'An error occurred while fetching campaign list.',
        },
      })
    );
  }
}

export function* watchCreateCampaignSaga() {
  yield takeLatest(createCampaign.type, createCampaignSaga);
  yield takeLatest(updateCampaign.type, updateCampaignSaga);
  yield takeLatest(pauseOrResumeCampaign.type, pauseOrResumeCampaignSaga);
  yield takeLatest(pauseOrResumeCampaignList.type, pauseOrResumeCampaignSaga);
}
